import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';

export enum Situation {
  open = 'OPEN',
  liquidated = 'SETTLED',
}

export enum FilterByDate {
  issue = 'EMISSION',
  maturity = 'DUE',
  receipt = 'PAY',
}

export enum ReportType {
  issue = 'EMISSION',
  maturity = 'DUE',
  receipt = 'PAY',
  chartOfAccounts = 'PLAN_ACCOUNT',
  planAccountSynthetic = 'PLAN_ACCOUNT_SYNTHETIC',
}

export enum OrderBy {
  date = 'DATE',
  description = 'DESCRIPTION',
  debtor = 'DEBTOR',
  code = 'CODE',
  planAccount = 'PLAN_ACCOUNT',
  documentType = 'DOCUMENT_TYPE',
}

export interface FinancialBillsToReceiveFormValues extends ReportDateInterface {
  bankAccountIds: number[];
  costCenterIds: number[];
  customersIds: number[];
  dateType: FilterByDate;
  lsSituacao: Situation;
  planAccountIds: number[];
  reportType: ReportType;
  documentTypeIds: number[];
  synthetic?: boolean;
  reportSortType: OrderBy;
  insurersIds: number[];
  analitic?: boolean;
  isExcludedDocumentType?: boolean;
}

export interface FinancialBillsToReceiveRequestQuery
  extends FinancialBillsToReceiveFormValues {
  format: string;
  analitic?: boolean;
  landingPage?: boolean;
}
